export type Optional<T> = T | undefined | null;

export enum ImageServiceType {
  ImageJpeg,
  ImagePng,
  BlurJpeg,
  BlurPng,
  Metadata,
  WhitePng,
}

export enum NATIVE_EVENT_KEY {
  CONTINUE_PLAYING = 'continuePlaying',
  ACCOUNT_MENU = 'accountMenu',
  LIST_MEDIA_SERIES = 'listMediaSeries',
  LIST_MEDIA_ITEMS_PER_SERIES = 'listMediaItemsPerSeries',
}

export enum CALLOUT_KEY {
  ACCOUNT_MENU_BUTTON = 'account-avatar-callout',
  ACCOUNT_MENU_BUTTON_PRECHECK_CALLOUT = 'precheck-callout',
}

type NATIVE_EVENT_KEY_ID = `${NATIVE_EVENT_KEY}-${string}`;

export interface Link {
  href: string;
}

export interface IAppImage {
  url: string;
  type: string;
  templated: boolean;
  aspectRatio: number;
}

export interface IAppState {
  title?: string;
  images?: IAppImage[];
}

export interface IAppStates {
  loading?: IAppState;
}

export interface BridgeAction {
  handler: string;
  command?: string;
  url?: string;
  contentUrl?: string;
  nativeEventKey?: NATIVE_EVENT_KEY | NATIVE_EVENT_KEY_ID;
  states?: IAppStates; // use case: app handler loading state

  [key: string]: any;
}

export type DispatchEvent =
  | {
      type: 'AUTH_CALLBACK';
      payload: {
        refresh: string;
      };
    }
  | {
      type: 'AUTHENTICATE_USER';
      appKey?: string;
      orgKey?: string;
      source?: string;
      targetAuthProviderId?: string;
      customReturnUrl?: string;
      openInNewTab?: boolean;
    }
  | { type: 'SET_SNACKBAR_MESSAGE'; payload: string }
  | { type: 'REFRESH_TOKEN' }
  | { type: 'DEAUTHENTICATE_USER' }
  | {
      type: 'LOG_GA_EVENT';
      payload: { event: string; data: Record<string, unknown> };
    }
  | {
      type: 'LOG_GA_VIRTUAL_PAGEVIEW';
      page: string;
    };

export type ActionTypeAndPayloadObj = {
  payload?: unknown;
  type: string;
};

export enum IndicatorSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  ExtraLarge = 'xl',
}

export enum ItemAlignment {
  Start = 'start',
  End = 'end',
  Center = 'center',
}

export enum ItemTextPosition {
  Below = 'below',
  Overlay = 'overlay',
  None = 'none',
}

export enum RadiusStyle {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  ExtraLarge = 'xl',
  Circle = 'circle',
  None = 'none',
}

export type ILabelSize = 'DK-1201' | 'DK-1202' | 'DK-2205';

export type ILocation = {
  app_key: string;
  title?: string;
  type: string[];
  _embedded?: {
    address?: {
      id: string;
      app_key: string;
      street?: string;
      street2?: string;
      city?: string;
      state?: string;
      postal_code?: string;
      country?: string | null;
      country_obj?: {
        code: string;
        name: string;
      } | null;
      latitude?: number;
      longitude?: number;
      created_at: string;
      deleted_at: string;
    };
  };
};

export type Subdivision = { code: string; name: string };
export type CountryWithSubdivisions = { subdivisions: Subdivision[] };
export type Country = { code: string; name: string };

export enum CONTEXT_TYPES {
  NETWORK = 'network',
  CACHE = 'cache',
}
